import { Component, OnInit } from '@angular/core';
import { CanActivate, Router }    from '@angular/router';

import { User } from '../classes/user';
import { UserService } from './user.service'
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
    public user:User;
    public bpassword:string;
    public errormessage:String;
    public buttonlabel:String;

  constructor(private userService:UserService, private router: Router, private loginService: LoginService) { }

  ngOnInit() {
      this.userService.getUser()
      .subscribe((data) => {
        if (data != null && data.error==null) {
            this.user=data.user
            console.log('returned user json: ' + JSON.stringify(this.user, null, 2));
            if (data.user==null) {  // No user (admin mode)
                this.user=new User()   // Creation mode (=> admin)
                this.user.hotel=this.loginService.user.hotel;
                this.buttonlabel="Créer et envoyer un email à l'hôtel"
            } else {
                this.buttonlabel="Valider"
            }
            
        } else {  // User not found, get error message
          this.errormessage = "Erreur au chargement des données";
          console.log('Erreur au chargement des données')
          // this.router.navigate(['/errorpage']);
        }
      });      
  }

  private onSubmit() {  // Save user
      if (this.user.user) { // User exists, update mode
          console.log("On user submit, update mode");
          this.userService.updateUser(this.user)
          .subscribe((data) => {
              if (data != null && data.error==null) {
                  console.log('Updated user');
              } else {  // Error message
                  this.errormessage = "Erreur à la mise à jour de l'utilisateur";
                  console.log("Erreur à la mise à jour de l'utilisateur")
                  this.router.navigate(['/user']);
              }
          });      
      } else {      // User creation => admin
          console.log("On user submit, create mode");
          this.userService.createUser(this.user)
          .subscribe((data) => {
              if (data != null && data.error==null) {
                  console.log('Created user: ' + data.data);
                  this.user.user=data.data;
              } else {  // Book not found, get error message
                  this.errormessage = "Erreur à la création de l'utilisateur";
                  console.log("Erreur à la création de l'utilisateur")
                  this.router.navigate(['/user']);
              }
          });
      }
      this.buttonlabel="Valider"
  }
}
